export const MARK_ITEM_AS_RESERVED_URL = (itemId: number): string =>
  `/member/items/reservation?id=${itemId}`
export const MARK_ITEM_AS_SOLD_URL = (itemId: number): string =>
  `/member/items/close?act_as=sold&id=${itemId}`
